// extracted by mini-css-extract-plugin
export default {"topBox":"styles_topBox__S6nz5","title":"styles_title__0cJ2K","text":"styles_text__8akm8","button":"styles_button__3z8MY"};